// Возвращает классы бейджа по типу периода (как в турнирах).
export function getTypeBadgeClasses(type) {
    switch (type) {
        case "daily":
            return "px-2 py-1 rounded-full text-xs whitespace-nowrap flex-shrink-0 bg-brand-success/20 text-black";
        case "weekly":
            return "px-2 py-1 rounded-full text-xs whitespace-nowrap flex-shrink-0 bg-brand-warning/30 text-black";
        case "monthly":
            return "px-2 py-1 rounded-full text-xs whitespace-nowrap flex-shrink-0 bg-brand-accent/30 text-black";
        default:
            return "px-2 py-1 rounded-full text-xs whitespace-nowrap flex-shrink-0 bg-gray-100 text-black";
    }
}

// Возвращает светлый вариант бейджа времени окончания турнира.
export function getTournamentTimeBadgeClasses(type) {
    switch (type) {
        case "daily":
            return "px-2 py-1 rounded-full text-xs whitespace-nowrap flex-shrink-0 bg-emerald-100 text-emerald-900 border border-emerald-200";
        case "weekly":
            return "px-2 py-1 rounded-full text-xs whitespace-nowrap flex-shrink-0 bg-amber-100 text-amber-900 border border-amber-200";
        case "monthly":
            return "px-2 py-1 rounded-full text-xs whitespace-nowrap flex-shrink-0 bg-sky-100 text-sky-900 border border-sky-200";
        default:
            return "px-2 py-1 rounded-full text-xs whitespace-nowrap flex-shrink-0 bg-gray-100 text-gray-900 border border-gray-200";
    }
}
